import {useEffect, useState} from 'react';

export const useDynamicPlaceholder = ({
  placeholder,
  placeholderDynamicTexts,
}: {
  placeholder?: string;
  placeholderDynamicTexts?: Array<{reason: string}>;
}) => {
  const [dynamicPlaceholder, setDynamicPlaceholder] = useState(
    placeholder ?? '',
  );

  useEffect(() => {
    const changePlaceholder = async () => {
      const dynamicPlaceholderTexts = placeholderDynamicTexts?.flatMap(
        (item) => item.reason,
      );
      //Цикл по всем текстам
      for (const text of dynamicPlaceholderTexts!) {
        // eslint-disable-next-line no-async-promise-executor
        await new Promise(async (res) => {
          //Лепим части предложения
          let partialText = '';
          //Цикл по буквам в предложении
          for (const letter of text) {
            await new Promise((subRes) => {
              const letterTimeout = setTimeout(() => {
                partialText += letter;

                setDynamicPlaceholder(partialText);
                subRes(null);
                clearTimeout(letterTimeout);
              }, 120);
            });
          }
          const textTimeout = setTimeout(() => {
            res(null);
            clearTimeout(textTimeout);
            //Перезапуск, когда все слова прошли
            if (
              dynamicPlaceholderTexts?.[dynamicPlaceholderTexts?.length - 1] ===
              text
            ) {
              changePlaceholder();
            }
          }, 300);
        });
      }
    };
    if (placeholderDynamicTexts?.length) {
      changePlaceholder();
    }
  }, []);

  return {
    dynamicPlaceholder,
  };
};
